import { windowHelper } from '@tencent/ppd-base-libs';

/** 判断页面打开环境 */
export function isInWeixin(): boolean {
  const ua = navigator.userAgent.toLowerCase();
  const matchResult = ua.match(/MicroMessenger/i);
  if (!matchResult) {
    return false;
  }
  return true;
  // const [result = ''] = matchResult;
  // return result === 'micromessenger'; // 这似乎是必然的了
}

/** 跳转引导下载微信 */
export function goDownloadWx() {
  windowHelper.redirect('https://www.wechat.com/mobile/en/', 200);
}

/** 端外拉起小程序并打开指定url，小程序schema带参数：url=base64(H5_url) */
export function openMiniProgam(urlSchema: string) {
  windowHelper.redirect(urlSchema, 200);
}
